import { BufferAttribute } from 'three';

export const isBufferAttribute = (attr: any): attr is BufferAttribute =>
  attr && attr.isBufferAttribute;

export default isBufferAttribute;
